import type { DisclosureContentProps } from '@ariakit/react';
import { Dialog as AriakitDialog } from '@ariakit/react';
import { domAnimation, motion } from 'framer-motion';

import FramerMotion from './FramerMotion';

type Props = {
  backdropProps?: Omit<DisclosureContentProps<'div'>, 'state'>;
  children?: React.ReactNode;
  className?: string;
  isOpen: boolean;
  onDismiss: () => void;
};

export const Dialog = ({ className, isOpen, onDismiss, children }: Props) => {
  return (
    <FramerMotion feature={domAnimation}>
      <AriakitDialog
        className={`fixed top-0 z-50 flex size-full items-center justify-center`}
        onClose={onDismiss}
        open={isOpen}
        onClick={onDismiss}
        backdrop={
          <motion.div
            className="bg-black/50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
        }
        render={
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
        }
      >
        <div
          className={className}
          role="button"
          tabIndex={0}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.stopPropagation();
            }
          }}
        >
          {children}
        </div>
      </AriakitDialog>
    </FramerMotion>
  );
};

export { DialogDismiss } from '@ariakit/react/dialog';
